import { render } from "./DocumentFilter.vue?vue&type=template&id=340af29f&scoped=true"
import script from "./DocumentFilter.vue?vue&type=script&lang=js"
export * from "./DocumentFilter.vue?vue&type=script&lang=js"

import "./DocumentFilter.vue?vue&type=style&index=0&id=340af29f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340af29f"]])

export default __exports__